import { RevokeWarrantyParams, UpdateWarrantyNoteParams, WarrantyInfo } from 'src/Libs/installation-details/api/types'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from '@e3dc-react/shell/Types'

export const updateWarrantyNote = async ({
  authFetch,
  data,
  installationId,
  deviceLinkId,
  installationStatementId,
}: UpdateWarrantyNoteParams): Promise<ApiResult<void>> => {
  const response = await authFetch<void>({
    path: `installations/${installationId}/device-links/${deviceLinkId}/statements/${installationStatementId}/warranties`,
    method: 'PUT',
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    payload: data,
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}

/**
 * Mark the most recent warranty certificate as not valid anymore without releasing or changing the installation statement
 */
export const revokeWarranty = async ({
  installationId,
  deviceLinkId,
  installationStatementId,
  reason,
  authFetch,
}: RevokeWarrantyParams): Promise<ApiResult<void>> => {
  if (!installationId || !deviceLinkId || !installationStatementId) {
    return new ApiResult<void>(null, true)
  }

  const response = await authFetch<void>({
    path: `installations/${installationId}/device-links/${deviceLinkId}/statements/${installationStatementId}/warranties/revoke`,
    method: 'PUT',
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    payload: {
      reason,
    },
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}

export const getWarrantyInfo = async (
  installationId: string | undefined,
  deviceLinkId: number | undefined,
  installationStatementId: number | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<WarrantyInfo>> => {
  if (!installationId || !deviceLinkId || !installationStatementId) {
    return new ApiResult<WarrantyInfo>(null, true)
  }

  const response = await authFetch<WarrantyInfo>({
    path: `installations/${installationId}/device-links/${deviceLinkId}/statements/${installationStatementId}/warranties`,
    method: 'GET',
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
  })

  if (response.status === StatusCodes.OK || response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<WarrantyInfo>(response.data, false)
  }

  return new ApiResult<WarrantyInfo>(null, true)
}
